module.exports = __webpack_public_path__ + "img/pickup_truck_h.c70e0e50.png";